"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SavedCard = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constants = require("./constants");

var SavedCard = {
  CardType: _propTypes.default.string,
  CreditCard: _propTypes.default.string,
  ExpiryDate: _propTypes.default.string,
  AccountHolder: _propTypes.default.string,
  PreferredCard: _propTypes.default.bool,
  DefaultCard: _propTypes.default.bool,
  VirtualNo: _propTypes.default.string,
  ProcessingFee: _propTypes.default.shape({
    amount: _propTypes.default.number,
    currency: _propTypes.default.string
  })
};
exports.SavedCard = SavedCard;
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    data: _propTypes.default.shape(SavedCard),
    translation: _propTypes.default.shape({
      cardHolder: _propTypes.default.string,
      expires: _propTypes.default.string,
      defaultTag: _propTypes.default.string
    }),
    onClick: _propTypes.default.func,
    cardWidth: _propTypes.default.string,
    cardTypeImages: _propTypes.default.object,
    cardTypeDefaultImage: _propTypes.default.string,
    isPaymentPage: _propTypes.default.bool,
    isSelected: _propTypes.default.bool,
    isEnableCvv: _propTypes.default.bool,
    handleField: _propTypes.default.func,
    formRef: _propTypes.default.object,
    onSavedCardToggle: _propTypes.default.func,
    cardLogoSource: _propTypes.default.object
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    translation: _constants.DEFAULT_TRANSLATIONS,
    onClick: function onClick() {},
    cardWidth: _constants.SAVED_CARD_WIDTH,
    cardTypeImages: _constants.CARD_TYPE_BG,
    cardTypeDefaultImage: _constants.CARD_TYPE_BG_DEFAULT,
    isPaymentPage: false,
    isSelected: false,
    isEnableCvv: false,
    handleField: function handleField() {},
    onSavedCardToggle: function onSavedCardToggle() {}
  }
};
exports.default = _default;